import React from 'react';

const DurationSummaryItem = ({ duration, duration95QR }) => {
  const isValidDuration = duration && duration95QR;
  const durationText = isValidDuration
    ? `${
        Math.round(duration.prediction) +
        'mins or up to ' +
        Math.round(duration95QR.prediction) +
        'mins'
      }`
    : 'Predicted duration: Not available';
  return (
    <div className="summary-item">
      Predicted Duration
      <span>{durationText}</span>
    </div>
  );
};

export default DurationSummaryItem;
